import React from 'react';

import { checkFeatureFlagGate } from '@wac-web/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@wac-web/utils/feature-flags/feature-flag-manifest';
import { FormattedMessage } from 'react-intl';

import Heading from '@atlaskit/heading';
import CloudArrowUpIcon from '@atlaskit/icon/core/cloud-arrow-up';
import Lozenge from '@atlaskit/lozenge-next';
import { Inline, Stack, Text, xcss } from '@atlaskit/primitives-next';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

import { getAggregatedStatusColor, getAggregatedStatusText } from '@/common/utils';
import { useFastshiftSelector } from '@/state/hook';

import { messages } from './messages';

const containerStyle = xcss({
	borderRadius: '6px',
	borderColor: 'color.border',
	borderWidth: 'border.width',
	borderStyle: 'solid',
	padding: 'space.200',
});

const iconWrapperStyle = xcss({
	width: '32px',
	height: '32px',
	borderRadius: '8px',
	borderColor: 'color.border',
	borderWidth: 'border.width',
	borderStyle: 'solid',
});

export const RollupStatusSection: React.FC = () => {
	const isRollUpStatusEnabled = checkFeatureFlagGate(
		featureFlags.sxpFastshiftPortalEnableRollUpStatus,
	);

	const { pending: customerDomainPending, data: customerDomainData } = useFastshiftSelector(
		(state) => state.customerDomain,
	);

	return isRollUpStatusEnabled ? (
		<Inline space="space.150" xcss={containerStyle} alignBlock="stretch">
			{customerDomainPending ? (
				<Stack space="space.050" grow="fill">
					<Skeleton height="16px" width="100%" />
					<Skeleton height="12px" width="100%" />
				</Stack>
			) : (
				<>
					<Stack alignBlock="center" alignInline="stretch">
						<Stack xcss={iconWrapperStyle} alignBlock="center" alignInline="center">
							<CloudArrowUpIcon label="Cloud arrow up" color={token('color.icon.information')} />
						</Stack>
					</Stack>
					<Stack space="space.050" grow="fill">
						<Heading as="h2" size="small">
							<FormattedMessage {...messages.rollupStatusSectionTitle} />
						</Heading>
						<Text size="small">
							<FormattedMessage {...messages.rollupStatusSectionDescription} />
						</Text>
					</Stack>
					<Stack alignBlock="center" alignInline="stretch">
						<Lozenge
							appearance={getAggregatedStatusColor(customerDomainData?.overallStatusSimple || null)}
							isBold
						>
							<FormattedMessage
								{...getAggregatedStatusText(customerDomainData?.overallStatusSimple || null)}
							/>
						</Lozenge>
					</Stack>
				</>
			)}
		</Inline>
	) : null;
};
